module.exports = __webpack_public_path__ + "media/slow2-h265.0a016d76.mp4";